(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Panier : boutons + / − puis mise à jour automatique
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cart-form] [data-qty-minus], [data-cart-form] [data-qty-plus]');
    if (!btn) return;
    var input = btn.closest('[data-qty]').querySelector('input');
    var value = parseInt(input.value, 10) || 0;
    input.value = btn.hasAttribute('data-qty-plus') ? value + 1 : Math.max(0, value - 1);
    var form = btn.closest('form');
    var update = form.querySelector('[data-cart-update]');
    if (update) update.click();
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-qty]')) return;
    var update = event.target.closest('form').querySelector('[data-cart-update]');
    if (update) update.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Ferme le menu mobile quand on clique sur un lien ou en dehors
  document.addEventListener('click', function (event) {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu || !menu.open) return;
    if (!menu.contains(event.target) || event.target.closest('a')) {
      menu.open = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Boutons + / − de la quantité
  document.addEventListener('click', function (event) {
    var minus = event.target.closest('.sz-product__form [data-qty-minus]');
    var plus = event.target.closest('.sz-product__form [data-qty-plus]');
    if (!minus && !plus) return;
    var input = event.target.closest('[data-qty]').querySelector('input');
    var value = parseInt(input.value, 10) || 1;
    input.value = plus ? value + 1 : Math.max(1, value - 1);
  });

  // Miniatures sur mobile : faire défiler la galerie sans sauter la page
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.sz-product__thumb');
    if (!thumb) return;
    var target = document.querySelector(thumb.getAttribute('href'));
    var slides = document.querySelector('[data-gallery]');
    if (!target || !slides) return;
    event.preventDefault();
    slides.scrollTo({ left: target.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
